import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, Typography, Box } from '@mui/material';
import PropTypes from 'prop-types';
import IconHolder from '../Helpers/IconHolder';
import './CardVertical.scss';

export default function CardVertical(props) {

  const navigate = useNavigate();
  const { icon, name, detailsLink, local } = props;
  const onLinkClicked = (path) => {
    if (path) {
      if (path === '/landing/simplified-issue-term') {
        navigate('/landing/term-insurance', { state: { isFromSimplifiedIssueTerm: true } });
        return;
      }
      navigate(path);
    }
  };

  return (
    <Card className='card-vertical d-flex flex-column pointer-div' variant='elevation' onClick={() => onLinkClicked(detailsLink)}>
      <CardContent className='pb-0'>
        <div className="d-flex justify-content-center">
          <IconHolder icon={icon} local={local} viewBox="0 0 25 25"/>
        </div>
        <Typography variant="body1" component="div" align="center" className="mt-2 pt-2">
          <Box
            sx={{
              fontWeight: "fontWeightBold",
              fontSize: 15
            }}>
            {name}
          </Box>
        </Typography>
      </CardContent>
    </Card>
  );
}

CardVertical.propTypes = {
  icon: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  detailsLink: PropTypes.string,
  local: PropTypes.any
};
